/**
 * Утилиты проверки ролей RBAC для ЕАБД
 * Зеркало серверных хелперов из core/permissions.py
 */

const LEADERSHIP_ROLES = ['admin', 'director', 'deputy_director'];
const TASKS_MANAGER_ROLES = [...LEADERSHIP_ROLES, 'assistant'];
const ALL_DATA_ROLES = [...TASKS_MANAGER_ROLES, 'analyst'];

export function getUser() {
  return JSON.parse(localStorage.getItem('user') || '{}');
}

/** Руководство: может управлять, утверждать, видеть все */
export function isLeadership(user = null) {
  const u = user || getUser();
  return u.is_staff || u.is_superuser || LEADERSHIP_ROLES.includes(u.role);
}

/** Полный read-access: руководство + analyst */
export function hasFullReadAccess(user = null) {
  const u = user || getUser();
  return u.is_staff || u.is_superuser || ALL_DATA_ROLES.includes(u.role);
}

/** Только admin: настройки, пользователи, справочники */
export function isAdminOnly(user = null) {
  const u = user || getUser();
  return u.is_superuser || (u.is_staff && (u.role === 'admin' || !u.role));
}

/** Может утверждать отчёты (руководство + department_head своего отдела) */
export function canApproveReports(user = null) {
  const u = user || getUser();
  return isLeadership(u) || u.role === 'department_head';
}

/** Может управлять задачами и проектами (руководство + помощники) */
export function canManageTasks(user = null) {
  const u = user || getUser();
  return u.is_staff || u.is_superuser || TASKS_MANAGER_ROLES.includes(u.role);
}

/** Analyst — read-only */
export function isAnalyst(user = null) {
  const u = user || getUser();
  return u.role === 'analyst';
}

/** Обычный сотрудник (employee или department_head) */
export function isDepartmentUser(user = null) {
  const u = user || getUser();
  return ['department_head', 'employee'].includes(u.role);
}
